export default __webpack_public_path__ + "static/media/file_image_1.63968ea3.svg";